import { data } from '../../svg/Campaign/data';
import { makeIcon } from '../makeIcon';

export const Campaign = makeIcon(data, 'campaign', 'Campaign');

export default Campaign;
